import { render } from "./vstatementdetails.vue?vue&type=template&id=38de209a&scoped=true"
import script from "./vstatementdetails.vue?vue&type=script&lang=js"
export * from "./vstatementdetails.vue?vue&type=script&lang=js"

import "./vstatementdetails.vue?vue&type=style&index=0&id=38de209a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38de209a"]])

export default __exports__